<template>
  <div id="menuTop" class="font-1 d-flex px-3 w-100" :class="menu" style="">
    <div class="d-flex h-100 w-100 topSpace">
      <div class=" col-8 d-flex justify-content-start align-items-center h-100">
        <div
          class="col-xxl-12 col-xl-10 col-lg-10 col-md-6  col-8 col-sm-8 d-flex justify-content-start align-items-center h-100"
          @click="goTo('home')">
          <img :src="a2" class="logo cursor-pointer_mod" v-if="menu === 'white' || menu === 'veige'">
          <img :src="a5" class="logo" v-else-if="menu === 'black' || menu === 'dark'">
        </div>
        <div
          class="col-xxl-4 col-xl-6 col-lg-6 col-md-6 col-sm-4 col-4 d-flex justify-content-end align-items-center h-100 nuevos-enlaces vanish visible">

          <a class="linkAccess3 link w-100 font-7 my-" :class="{ active: $route.name === 'flow' }"
            @click="goTo('flow')">FLOW</a>

            <a class="linkAccess3 link w-100 font-7 my- border-left" :class="{ active: $route.name === 'order' }"
            @click="goTo('order')">ORDER</a>


          <a class="linkAccess3 link w-100 font-7 my- border-left" :class="{ active: $route.name === 'intel' }"
            @click="goTo('intel')">INTEL</a>

          <a class="linkAccess3 link w-100 font-7 my-" :class="{ active: $route.name === 'insight' }"
            @click="goTo('insight')">FEEDBACK</a>

          <a class="linkAccess3 link w-100 font-7 my- border-left" :class="{ active: $route.name === 'reward' }"
            @click="goTo('reward')">REWARDS</a>

          <span class="barra-lateral"></span>
        </div>

      </div>
      <span class="linea-lateral"></span>
      <div class=" col-4 d-flex justify-content-end align-items-center h-100" :class="open ? 'open' : 'closed'">
        <span class="icon-action icon-1" @click="toggleMenu">
          <div class="line"></div>
          <div class="line"></div>
          <div class="line"></div>
        </span>
      </div>
    </div>

    <div class="fillspace" v-if="open"></div>

    <div :class="menu" class="openSpace d-flex flex-column justify-content-center align-items-start align-content-start"
      v-if="menuSelected === 1">
      <div class="close-btn" @click="toggleMenu">
        <span class="cerrar-nav"></span>
        <span class="cerrar-nav"></span>
      </div>
      <div
  class="col-12 d-flex justify-content-start text-start align-items-start align-content-start flex-wrap flex-fill">
  <span class="font-7 label-2 menu-experiencias mb-4">Experiencias memorables para tus clientes</span>

  <a class="linkAccess3 link w-100 font-7 my-2"
     :class="{ active: $route.name === 'flow' }"
     @click="goTo('flow')">Flow</a>

     <a class="linkAccess3 link w-100 font-7 my-2"
     :class="{ active: $route.name === 'order' }"
     @click="goTo('order')">Order</a>

  <a class="linkAccess3 link w-100 font-7 my-2"
     :class="{ active: $route.name === 'intel' }"
     @click="goTo('intel')">Intel</a>

  <a class="linkAccess3 link w-100 font-7 my-2"
     :class="{ active: $route.name === 'insight' }"
     @click="goTo('insight')">Feedback</a>

  <a class="linkAccess3 link w-100 font-7 my-2"
     :class="{ active: $route.name === 'reward' }"
     @click="goTo('reward')">Reward</a>

</div>

    </div>

    <div :class="menu" class="openSpace d-flex flex-column justify-content-center align-items-start align-content-start"
      v-else-if="menuSelected === 2">
      <span class="icon-close" @click="toggleMenu">✕</span>
      <div
        class="col-12 d-flex justify-content-start text-start align-items-start align-content-start flex-wrap flex-fill">
        <a class="linkAccess3 link w-100 font-7 mt-0 mb-4" :class="{ active: $route.name === 'flow' }"
          @click="goTo('flow')">Flow</a>
        <a class="linkAccess3 link w-100 font-7 my-4" :class="{ active: $route.name === 'order' }"
          @click="goTo('order')">Order</a>
        <a class="linkAccess3 link w-100 font-7 my-4" :class="{ active: $route.name === 'intel' }"
          @click="goTo('intel')">Intel</a>
        <a class="linkAccess3 link w-100 font-7 my-4" :class="{ active: $route.name === 'reward' }"
          @click="goTo('reward')">Rewardss</a>
        <a class="linkAccess3 link w-100 font-7 my-4" :class="{ active: $route.name === 'insight' }"
          @click="goTo('insight')">Insight</a>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'menutop',
  props: {
    menu: {
      type: String,
      default: 'white'
    }
  },
  data() {
    return {
      a2: require('@/assets/images/a2.webp'),
      a5: require('@/assets/images/a3.png'),
      dinW: 0,
      open: false,
      menuSelected: 0,
      showLinks: false
    }
  },
  async created() {
    const img1 = new Image();
    img1.src = await require('@/assets/images/a2.webp');
    const img2 = new Image();
    img2.src = await require('@/assets/images/a5.webp');
    this.showLinks = true;
    // setTimeout(() => {
    //     this.showLinks = true;
    // }, 2000);
  },
  mounted() {
    this.getDinW();
    //       setTimeout(() => {
    //   const enlaces = document.querySelector('.nuevos-enlaces');
    //   if (enlaces) enlaces.classList.add('visible');
    // }, 2000);

  },
  methods: {
    openMenu2() {
      this.open = true;
      this.menuSelected = 2;
    },
    toggleMenu() {
      this.open = this.menuSelected === 0;
      this.menuSelected = this.open ? 1 : 0;
    },
    getDinW() {
      const container = document.getElementById('master');
      if (container) {
        this.dinW = (container.offsetWidth - container.clientWidth > 0) ? container.offsetWidth - container.clientWidth : container.offsetWidth - 15;
        setTimeout(() => {
          this.dinW = container.offsetWidth - container.clientWidth;
        }, 1000);
      }
    },
    goTo(section) {
      this.$router.push({ name: section });
    }
  }
}
</script>

<style lang="css" scoped>
.fade-enter-active {
  transition: opacity 0.1s ease-in-out;
}

.fade-leave-active {
  transition: opacity 0.1s ease-in-out;
}

.fade-enter-from,
.fade-leave-to {
  opacity: 0;
}

.cerrar-nav {
  height: 6px !important;
}

.close-btn {
  position: absolute;
  top: 40px;
  right: 40px;
  width: 40px;
  height: 40px;
  cursor: pointer;
  z-index: 1100;
  display: flex;
  align-items: center;
  justify-content: center;
}

.close-btn span {
  position: absolute;
  width: 30px;
  height: 3px;
  background-color: #000;
  border-radius: 2px;
}

.close-btn span:first-child {
  transform: rotate(45deg);
}

.close-btn span:last-child {
  transform: rotate(-45deg);
}

.logo {
  max-width: 100%;
  height: auto;
  max-height: 50%;
}

.nuevos-enlaces {
  z-index: 1010;
  margin-left: 100px;
  opacity: 0;
  transition: opacity 0.1s ease-in;
}

.nuevos-enlaces.visible {
  opacity: 1;
}

.nuevos-enlaces a {
  margin: 0 20px;
  color: #000000;
}

.white .linkAccess3.active {
  color: #000000 !important;
}

.black .linkAccess3.active {
  color: #ffffff !important;
}

.menu-experiencias {
  line-height: 1.5 !important;
}

.btn2:hover {
  color: var(--color-8) !important;
}

.btn2:hover svg path {
  fill: var(--color-8);
}

.link {
  color: #9c9c9c !important;
}

.link:hover {
  color: #6b6e70 !important;
}

.openSpace {
  height: 100vh;
  max-width: 300px;
  width: 100%;
  position: fixed;
  padding: 35px;
  top: 0;
  padding-top: 115px;
  right: 0;
  border: 1px solid #000;
  z-index: 1050;
  transform: translateX(300px);
  animation: open 0.2s linear forwards;
}

.icon-close {
  position: absolute;
  top: 25px;
  right: 25px;
  font-size: 28px;
  font-weight: bold;
  cursor: pointer;
  z-index: 1100;
  color: #000;
}

@media (max-width: 600px) {
  .openSpace {
    transform: translateX(100vw);
    max-width: 100vw;
    width: 100vw;
  }
}

@keyframes open {
  0% {
    transform: translateX(100vw);
  }

  100% {
    transform: translateX(0);
  }
}

@keyframes fadeUp {
  0% {
    opacity: 0;
  }

  100% {
    opacity: 1;
  }
}

.topSpace {
  z-index: 1001;
}

.fillspace {
  position: fixed;
  top: 0;
  left: 0;
  z-index: 999;
  background-color: rgba(255, 255, 255, 0.7);
  width: 100vw;
  height: 100vh;
  animation: fadeUp 0.2s linear forwards;
}

#menuTop {
  position: sticky;
  top: 0;
  left: 0;
  /* opcional si quieres que ocupe todo el ancho del contenedor */
  height: 80px;
  z-index: 1001;
  /* para que quede encima del contenido al hacer scroll */
  /* quitas position: fixed */
}

.label-1 {
  font-size: 22px;
  line-height: 0;
}

.black .label-1,
.dark .label-1 {
  color: var(--color-5);
}

.veige .label-1,
.white .label-1 {
  color: var(--color-1);
}

.white .label-2 {
  color: var(--color-4);
}

.white .linkAccess {
  color: var(--color-3);
}

.white .linkAccess2 {
  color: var(--color-2);
}

.white .linkAccess3 {
  color: var(--color-4);
}

.white .btn2 svg path {
  fill: var(--color-4);
}

.black .label-2,
.black .linkAccess,
.black .linkAccess2,
.black .linkAccess3,
.black .btn2 svg path {
  color: var(--color-5);
  fill: var(--color-5);
}

.dark .label-2,
.dark .linkAccess,
.dark .linkAccess2,
.dark .linkAccess3,
.dark .btn2 svg path {
  color: var(--color-5);
  fill: var(--color-5);
}

.veige .label-2,
.veige .linkAccess,
.veige .linkAccess2,
.veige .linkAccess3,
.veige .btn2 svg path {
  color: var(--color-1);
  fill: var(--color-1);
}

.icon-1 {
  position: relative;
  height: 25px;
  width: 30px;
  cursor: pointer;
  display: block;
}

.line {
  height: 5px;
  width: 100%;
  position: absolute;
  transition: all 0.3s;
}

.line:nth-child(1) {
  top: 0;
}

.line:nth-child(2) {
  top: 50%;
  transform: translateY(-50%);
}

.line:nth-child(3) {
  bottom: 0;
}

.white .line {
  background-color: var(--color-2);
}

.black .line,
.dark .line {
  background-color: var(--color-5);
}

.veige .line {
  background-color: var(--color-1);
}

.white {
  background-color: #fff;
}

.black {
  background-color: var(--color-4);
}

.dark {
  background-color: var(--color-2);
}

.veige {
  background-color: var(--color-9);
}

.label-2 {
  font-size: 25px;
  line-height: 2;
}

.linkAccess,
.linkAccess2,
.linkAccess3 {
  cursor: pointer;
  outline: none;
  text-decoration: none;
}

.linkAccess {
  font-size: 18px;
  line-height: 1.1;
}

.linkAccess2 {
  font-size: 20px;
  line-height: 1.1;
}

.linkAccess3 {
  font-size: 22px;
  line-height: 1.1;
}

.bottomSpace {
  padding-top: 20px;
  border-top: 2px solid var(--color-2);
}

.open .icon-1 .line:nth-child(2) {
  display: none;
}

.open .icon-1 .line:nth-child(1) {
  transform: translateY(10px) rotate(45deg);
}

.open .icon-1 .line:nth-child(3) {
  transform: translateY(-10px) rotate(-45deg);
}

.cursor-pointer_mod {
  cursor: pointer;
}

@media screen and (max-width: 1280px) {
  .nuevos-enlaces {
    z-index: 1010;
    margin-left: 50px;
  }
}

@media screen and (max-width: 992px) {
  .nuevos-enlaces {
    display: none !important;
  }
}
</style>
